import { render, staticRenderFns } from "./custom-conversions-sending.vue?vue&type=template&id=e8da937c&scoped=true&"
import script from "./custom-conversions-sending.vue?vue&type=script&lang=ts&"
export * from "./custom-conversions-sending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8da937c",
  null
  
)

export default component.exports